export default function ({ store, redirect }) {
  const university = store.state.universities.active
  if (!helpers.isEmpty(university)) {
    redirect('/login')
  }
}
